

import React from 'react'
import Member from './Member'

function About() {
  return (
    <>
       <section className="bg-half-170 d-table w-100" style={{
            background: `url('assets/images/pages/aboutus.jpg')`,
            objectFit: 'cover',
            backgroundRepeat: 'no-repeat'
        }}>
            <div className="bg-overlay"></div>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-lg-12 text-center">
                        <div className="pages-heading title-heading">
                            <h2 className="text-white title-dark"> Бидний тухай </h2>
                            <p className="text-white-50 para-desc mb-0 mx-auto"></p>
                        </div>
                    </div>
                </div>
                
                <div className="position-breadcrumb">
                    <nav aria-label="breadcrumb" className="d-inline-block">
                        <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                            <li className="breadcrumb-item"><a href="/">Эхлэл</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Бидний тухай</li>
                        </ul>
                    </nav>
                </div>
            </div> 
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-color-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
       

      
        <div className="position-relative">
            <div className="shape overflow-hidden text-color-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
      

        
        <section className="section">
            <div className='container '>
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">Алсын хараа</h4>
                            <p className="text-muted para-desc mx-auto mb-0 text-justify">Уул уурхайн салбарын тогтвортой хөгжлийг шинжлэх ухаан, технологи, 
                                инновацид тулгуурлан тэргүүлнэ.</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">Эрхэм зорилго</h4>
                            <p className="text-muted para-desc mx-auto mb-0 text-justify">Шинжлэх ухааны судалгаа, технологийн инноваци, бодлогын зөвлөмжөөр дамжуулан уул уурхайн салбарын үр ашгийг нэмэгдүүлж,
                                 зардлыг бууруулах, байгаль орчинд ээлтэй, хариуцлагатай, тогтвортой үйл ажиллагааг дэмжих.</p>
                        </div>
                    </div>
                </div>
            </div>

  
            <div className="container mt-5">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="position-relative">
                            <img src="assets/images/illustrator/team-meeting.svg" className="rounded img-fluid mx-auto d-block" alt="" />
                            {/* <div className="play-icon">
                                <a href="#!" data-type="youtube" data-id="yba7hPeTSjk" className="play-btn lightbox border-0">
                                    <i className="mdi mdi-play text-primary rounded-circle shadow"></i>
                                </a>
                            </div> */}
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="section-title ms-lg-4">
                            <h4 className="title mb-4"><span className="text-primary fw-bold">MINE INTELLECT</span> ХХК</h4>
                            <p className="text-muted text-justify">Уул уурхайн салбарын эрдэм шинжилгээ, бодлогын судалгаа, технологи нэвтрүүлэлтийн чиглэлээр ажилладаг, хараат бус мэргэжлийн байгууллага юм. Бид шинжлэх ухааны суурьтай шийдэл, 
                                инновацийн үр дүнг үйлдвэрлэлд нэвтрүүлж, салбарын хөгжлийг хурдасгахыг эрхэмлэдэг.</p>
                            {/* <a href="javascript:void(0)" className="btn btn-primary mt-3">Buy Now <i className="uil uil-angle-right-b"></i></a> */}
                            <div className="d-flex align-items-center text-start mt-4 pt-2">
                                <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                                    <i className="uil uil-capture"></i>
                                </div>
                                <div className="flex-1">
                                    <a href="#" className="text-dark h6">Мэргэжлийн</a>
                                </div>
                            </div>

                            <div className="d-flex align-items-center text-start mt-4">
                                <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                                    <i className="uil uil-file"></i>
                                </div>
                                <div className="flex-1">
                                    <a href="#" className="text-dark h6">Чанартай</a>
                                </div>
                            </div>

                            <div className="d-flex align-items-center text-start mt-4">
                                <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                                    <i className="uil uil-tachometer-fast"></i>
                                </div>
                                <div className="flex-1">
                                    <a href="#" className="text-dark h6">Шуурхай</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">Үйл ажиллагааны үндсэн чиглэлүүд</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Бид дараах үндсэн чиглэлүүдээр үйл ажиллагаагаа явуулдаг.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="file" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">Шинжлэх ухаан, технологийн судалгаа хөгжүүлэлт</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-6 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="monitor" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">Инноваци ба дижитал шилжилт</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-6 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="eye" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">Бодлогын зөвлөмж, зөвлөх үйлчилгээ</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-6 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="bold" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">Сургалт ба мэдлэгийн менежмент</h4>
                            </div>
                        </div>
                    </div>
                    
                    {/* <div className="col-lg-4 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="feather" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">Feather Icons</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="code" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">Built With SASS</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="user-check" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">W3c Valid Code</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="git-merge" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">Flaticon Icons</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 mt-4 pt-2">
                        <div className="d-flex features feature-primary key-feature align-items-center p-3 rounded shadow">
                            <div className="icon text-center rounded-circle me-3">
                                <i data-feather="settings" className="fea icon-ex-md"></i>
                            </div>
                            <div className="flex-1">
                                <h4 className="title mb-0">Easy to customize</h4>
                            </div>
                        </div>
                    </div> */}
                    
                    <div className="col-12 mt-4 pt-2 text-center">
                        <a href="/service" className="btn btn-primary">Дэлгэрэнгүй <i className="mdi mdi-arrow-right"></i></a>
                    </div>
                </div>
            </div>

        </section>
               
        <Member />       
       {/*  <section className="section bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">Our Greatest Minds</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Start working with <span className="text-primary fw-bold">Landrick</span> that can provide everything you need to generate awareness, drive traffic, connect.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-3 col-md-6 mt-4 pt-2">
                        <div className="card team team-primary text-center bg-transparent border-0">
                            <div className="card-body p-0">
                                <div className="position-relative">
                                    <img src="assets/images/client/01.jpg" className="img-fluid avatar avatar-ex-large rounded-circle" alt="" />
                                    <ul className="list-unstyled mb-0 team-icon">
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="facebook" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="instagram" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="twitter" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="linkedin" className="icons"></i></a></li>
                                    </ul>
                                </div>
                                <div className="content pt-3 pb-3">
                                    <h5 className="mb-0"><a href="javascript:void(0)" className="name text-dark">Ronny Jofra</a></h5>
                                    <small className="designation text-muted">C.E.O</small>
                                </div>                                
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 mt-4 pt-2">
                        <div className="card team team-primary text-center bg-transparent border-0">
                            <div className="card-body p-0">
                                <div className="position-relative">
                                    <img src="assets/images/client/04.jpg" className="img-fluid avatar avatar-ex-large rounded-circle" alt="" />
                                    <ul className="list-unstyled mb-0 team-icon">
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="facebook" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="instagram" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="twitter" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="linkedin" className="icons"></i></a></li>
                                    </ul>
                                </div>
                                <div className="content pt-3 pb-3">
                                    <h5 className="mb-0"><a href="javascript:void(0)" className="name text-dark">Micheal Carlo</a></h5>
                                    <small className="designation text-muted">Director</small>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-3 col-md-6 mt-4 pt-2">
                        <div className="card team team-primary text-center bg-transparent border-0">
                            <div className="card-body p-0">
                                <div className="position-relative">
                                    <img src="assets/images/client/02.jpg" className="img-fluid avatar avatar-ex-large rounded-circle" alt="" />
                                    <ul className="list-unstyled mb-0 team-icon">
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="facebook" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="instagram" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="twitter" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="linkedin" className="icons"></i></a></li>
                                    </ul>
                                </div>
                                <div className="content pt-3 pb-3">
                                    <h5 className="mb-0"><a href="javascript:void(0)" className="name text-dark">Aliana Rosy</a></h5>
                                    <small className="designation text-muted">Manager</small>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-3 col-md-6 mt-4 pt-2">
                        <div className="card team team-primary text-center bg-transparent border-0">
                            <div className="card-body p-0">
                                <div className="position-relative">
                                    <img src="assets/images/client/03.jpg" className="img-fluid avatar avatar-ex-large rounded-circle" alt="" />
                                    <ul className="list-unstyled mb-0 team-icon">
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="facebook" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="instagram" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="twitter" className="icons"></i></a></li>
                                        <li className="list-inline-item"><a href="javascript:void(0)" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="linkedin" className="icons"></i></a></li>
                                    </ul>
                                </div>
                                <div className="content pt-3 pb-3">
                                    <h5 className="mb-0"><a href="javascript:void(0)" className="name text-dark">Sofia Razaq</a></h5>
                                    <small className="designation text-muted">Developer</small>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title">
                            <h4 className="title mb-4">See everything about your employee at one place.</h4>
                            <p className="text-muted para-desc mx-auto">Start working with <span className="text-primary fw-bold">Landrick</span> that can provide everything you need to generate awareness, drive traffic, connect.</p>
                        
                            <div className="mt-4">
                                <a href="javascript:void(0)" className="btn btn-primary mt-2 me-2">Get Started Now</a>
                                <a href="javascript:void(0)" className="btn btn-outline-primary mt-2">Free Trial</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}

        <section className="section pt-0">
            <div className="container">
                <div className="row justify-content-center">
                    <h4 className="title text-center mb-4">Түүхэн хөгжил</h4>
                    <div className="col-lg-9">
                        <div className="main-icon rounded-pill text-primary text-center mt-1 pt-2">
                            <i data-feather="star" className="fea icon-md-sm"></i>
                        </div>
                        <div className="timeline-page pt-2 position-relative">
                            <div className="timeline-item mt-4">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="duration date-label-left border rounded p-2 px-4 position-relative shadow">2025</div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="card event event-description-right rounded shadow border-0 overflow-hidden float-start">
                                            <img src="assets/images/blog/01.jpg" className="img-fluid" alt="" />
                                            <div className="card-body">
                                                <h5 className="mb-0 text-capitalize">Үүсэл</h5>
                                                <p className="mt-3 mb-0 text-muted">MINE INTELLECT ХХК үүсэн байгуулагдав.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            {/* <div className="timeline-item mt-4">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6 order-sm-1 order-2">
                                        <div className="card event event-description-left rounded shadow border-0 overflow-hidden float-start" />
                                            <img src="assets/images/blog/02.jpg" className="img-fluid" alt="" />
                                            <div className="card-body">
                                                <h5 className="mb-0 text-capitalize">Partnership</h5>
                                                <p className="mt-3 mb-0 text-muted">The generated injected humour, or non-characteristic words etc. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 order-sm-2 order-1">
                                        <div className="duration duration-right rounded border p-2 px-4 position-relative shadow text-start">2006</div>
                                    </div>
                            </div>
                         
        
                            <div className="timeline-item mt-4">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="duration date-label-left border rounded p-2 px-4 position-relative shadow">2012</div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="card event event-description-right rounded shadow border-0 overflow-hidden float-start">
                                            <img src="assets/images/blog/03.jpg" className="img-fluid" alt="" />
                                            <div className="card-body">
                                                <h5 className="mb-0 text-capitalize">Secuirty</h5>
                                                <p className="mt-3 mb-0 text-muted">The generated injected humour, or non-characteristic words etc. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <div className="timeline-item mt-4">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6 order-sm-1 order-2">
                                        <div className="card event event-description-left rounded shadow border-0 overflow-hidden float-start">
                                            <img src="assets/images/blog/04.jpg" className="img-fluid" alt="" />
                                            <div className="card-body">
                                                <h5 className="mb-0 text-capitalize">Branch</h5>
                                                <p className="mt-3 mb-0 text-muted">The generated injected humour, or non-characteristic words etc. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 order-sm-2 order-1">
                                        <div className="duration duration-right rounded border p-2 px-4 position-relative shadow text-start">2013</div>
                                    </div>
                                </div>
                            </div>
        
                            <div className="timeline-item mt-4">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="duration date-label-left border rounded p-2 px-4 position-relative shadow">2016</div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="card event event-description-right rounded shadow border-0 overflow-hidden float-start">
                                            <img src="assets/images/blog/05.jpg" className="img-fluid" alt="" />
                                            <div className="card-body">
                                                <h5 className="mb-0 text-capitalize">Global</h5>
                                                <p className="mt-3 mb-0 text-muted">The generated injected humour, or non-characteristic words etc. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <div className="timeline-item mt-4">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6 order-sm-1 order-2">
                                        <div className="card event event-description-left rounded shadow border-0 overflow-hidden float-start">
                                            <img src="assets/images/blog/06.jpg" className="img-fluid" alt="" />
                                            <div className="card-body">
                                                <h5 className="mb-0 text-capitalize">Branches</h5>
                                                <p className="mt-3 mb-0 text-muted">The generated injected humour, or non-characteristic words etc. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 order-sm-2 order-1">
                                        <div className="duration duration-right rounded border p-2 px-4 position-relative shadow text-start">2018</div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            
        </section>
    </>
  )
}

export default About